<template>
  <div v-if="visible">
    <Navbar :type="$type"/>

    <div class="container">
      <div class="box">
        <div class="columns is-centered" v-if="showTags">
          <div class="column is-half">
            <b-field label="Tags">
              <b-taginput
                :value="data.tags"
                @input="setTags"
                :data="tagsAutofill"
                autocomplete
              ></b-taginput>
            </b-field>
          </div>
        </div>

        <form-wizard
          :data.sync="data"
          :fields="fields"
          :metadata="$metadata"
          @submit="onSubmit"
          hide-boxes
        ></form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import Library from 'library'
import Navbar from '@/components/ViewComponents/Navbar.vue'

export default {
  name: 'CreateInteraction',

  props: {
    customerId: {
      required: true
    }
  },

  data () {
    return {
      visible: true,
      center: {
        lat: 0,
        lng: 0
      },
      point: null,
      showPoint: false,
      useCustomerAddress: false,
      data: {
        customerId: this.customerId
      }
    }
  },

  methods: {
    async onSubmit (data) {
      const loader = this.$loading.open()
      try {
        await this.$entity.create('Interaction', data)

        this.$router.push({ name: 'View Customer', params: { id: data.customerId } })
      } catch (e) {
        console.error(e)
      } finally {
        loader.close()
      }
    },

    setTags (e) {
      this.$set(this.data, 'tags', e)
    }
  },

  computed: {
    fields () {
      return Library.Entities.getCreateFields(this.$type)
    },

    showTags () {
      if (this.$metadata && this.$metadata.properties && this.$metadata.properties.find(prop => prop.propertyName === 'tags')) {
        return true
      } else {
        return false
      }
    },

    tagsAutofill () {
      if (this.showTags) {
        const autofill = this.$metadata.properties.find(prop => prop.propertyName === 'tags');

        return autofill.options.possibleValues || []
      }
    }
  },

  components: {
    FormWizard: Library.Components.FormWizard,
    Navbar
  }
}
</script>
